/**
 * StreamingCursor — Cursor piscante durante streaming
 */
import { h } from 'preact';
import { T } from '../../styles/tokens';

export function StreamingCursor() {
  return (
    <span class="streaming-cursor" style={{
      color: T.purple,
      animation: 'cursorBlink 0.8s ease-in-out infinite',
      fontSize: 14,
      marginLeft: 1,
    }}>▊</span>
  );
}
